import { Element } from '../../../../../common/html/element'
import classes from './index.module.scss'
import { Left } from './Left'
import { Right } from './Right'

export const Header = () => {
  return (
    <Element
      className={classes.headerTab}
      style={{ borderBottom: '1px solid #b5cef8' }}
    >
      <Left />
      <Right />
    </Element>
  )
}
